import { PlayerSpeed } from "../model";

export const PLAYER_SPEED: PlayerSpeed[] = [
  "0,25",
  "0,5",
  "0,75",
  "1",
  "1,25",
  "1,5",
  "1,75",
  "2",
];

export const BASE_SPEED = "1";
